module.exports = __webpack_public_path__ + "static/media/police.18bc6396.jpg";